// extracted by mini-css-extract-plugin
export var blue = "SimpleButton-module--blue--52cca";
export var btn_icon = "SimpleButton-module--btn_icon--8c8f6";
export var colored = "SimpleButton-module--colored--9a72a";
export var gray = "SimpleButton-module--gray--37ea4";
export var simple_btn = "SimpleButton-module--simple_btn--efe5c";
export var solidRed = "SimpleButton-module--solidRed--ec2a3";
export var white = "SimpleButton-module--white--e4043";